The pagination metadata for this page of candidate process history items.
